import { useCallback } from 'react';
import {
  createTemplateFromCampaign,
  loadTemplateTreeForCopy,
  persistTemplateTree,
} from '../utils/templateCopy';
import { SprintAPI } from '../utils/api';

/**
 * useTemplateFromCampaign Hook
 *
 * Creates a template from an existing campaign, deep-copying nested campaigns.
 */
export function useTemplateFromCampaign({ sprints, loadFullSprint, setSprints, handleSelectTemplate }) {
  const handleCreateTemplateFromCampaign = useCallback(async (campaignId) => {
    const campaign = sprints.find(s => s.id === campaignId);
    if (!campaign) {
      console.error('[useTemplateFromCampaign] Campaign not found:', campaignId);
      return;
    }

    let fullCampaign;
    let loadedSprints;
    try {
      const loaded = await loadTemplateTreeForCopy(campaignId, sprints, loadFullSprint);
      fullCampaign = loaded.root;
      loadedSprints = loaded.sprints;
    } catch (error) {
      console.error('[useTemplateFromCampaign] Failed to load campaign:', error);
      return;
    }

    if (!fullCampaign) {
      console.error('[useTemplateFromCampaign] Campaign not found after load:', campaignId);
      return;
    }

    const { rootTemplate, nestedCampaigns } = createTemplateFromCampaign(fullCampaign, loadedSprints);

    try {
      const { createdTemplate, createdNested } = await persistTemplateTree({
        rootTemplate,
        nestedCampaigns,
        SprintAPI,
      });

      setSprints(prev => [...prev, createdTemplate, ...createdNested]);
      handleSelectTemplate(createdTemplate);

      console.log(
        '✅ Template created from campaign:',
        createdTemplate.name,
        'with',
        createdNested.length,
        'nested campaigns',
      );
    } catch (error) {
      console.error('[useTemplateFromCampaign] Failed to create template from campaign:', error);
    }
  }, [sprints, loadFullSprint, setSprints, handleSelectTemplate]);

  return { handleCreateTemplateFromCampaign };
}

export default useTemplateFromCampaign;
